export default "__VITE_ASSET__DZLI0d_7__"